import { useEffect, useRef, useState } from 'react';
import {
  applyUpdate,
  checkForUpdate,
  isUpdateReady,
  onUpdateReady,
} from '../serviceWorkerRegistration';

const POLL_MS = 2 * 60 * 1000;

export default function VersionWatcher() {
  const [stale, setStale] = useState(false);
  const current = useRef(null);

  const fetchVersion = () =>
    fetch('/version.json?t=' + Date.now())
      .then((r) => r.json())
      .catch(() => null);

  useEffect(() => {
    fetchVersion().then((data) => {
      if (data?.version) current.current = data.version;
    });

    const id = setInterval(() => {
      fetchVersion().then((data) => {
        if (data?.version && current.current && data.version !== current.current) {
          setStale(true);
          // version.json is deployed alongside the new build, but the browser
          // only re-checks the service worker on its own schedule. Nudge it so
          // a new worker is actually waiting by the time the user hits Refresh.
          checkForUpdate();
        }
      });
    }, POLL_MS);

    return () => clearInterval(id);
  }, []);

  // A worker can also become ready without the poll noticing first.
  useEffect(() => {
    if (isUpdateReady()) setStale(true);
    return onUpdateReady(() => setStale(true));
  }, []);

  if (!stale) return null;

  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 flex items-center gap-3 bg-card border border-border rounded-lg shadow-lg px-4 py-3 text-sm">
      <span className="text-foreground">A new version is available.</span>
      <button
        onClick={applyUpdate}
        className="text-primary font-medium hover:underline"
      >
        Refresh
      </button>
    </div>
  );
}
